    <!-- Procedure Category - Editable Input -->

        
    <!-- Status Visual -->
    <div>
        <div class="procedure-container">
            <label for="procedureCategory">Procedure:</label>
            {{editableEncounter?.referral?.procedures?.[0]?.displayName || ''}}
        </div>    
        <ul class="list-none p-0 m-0 flex flex-column md:flex-row">   
            <li class="relative mr-0 md:mr-8 flex-auto"> 
                <div class="border-1 surface-border border-round p-3 flex flex-column md:flex-row align-items-center z-1"
                        [ngClass]="editableEncounter?.status == 0 ? 'bg-primary-100' : 'surface-card' ">
                    <i class="pi pi-star text-2xl md:text-4xl mb-2 md:mb-0 mr-0 md:mr-3"></i>
                    <div>
                        <div class="text-900 font-medium mb-1">New</div>
                        <span class="text-600 text-sm hidden md:block">Submission received. Referral being generated</span>
                    </div>
                </div>
                <div class="w-full absolute top-50 left-100 surface-300 hidden md:block" style="transform: translateY(-50%); height: 2px"></div>
            </li>
            <li class="relative mr-0 md:mr-8 flex-auto">
                <div class="border-1 surface-border border-round p-3 flex flex-column md:flex-row align-items-center z-1"
                [ngClass]="editableEncounter?.status == 1 ? 'bg-primary-100' : 'surface-card' ">
                    <i class="pi pi-file-export text-2xl md:text-4xl mb-2 md:mb-0 mr-0 md:mr-3"></i>
                    <div>
                        <div class="text-900 font-medium mb-1">Referral Review</div>
                        <span class="text-600 text-sm hidden md:block">Waiting for adjuster approval</span>
                    </div>
                </div>
                <div class="w-full absolute top-50 left-100 surface-300 hidden md:block" style="transform: translateY(-50%); height: 2px"></div>
            </li>
            <li class="relative mr-0 md:mr-8 flex-auto">
                <div class="border-1 surface-border border-round p-3 flex flex-column md:flex-row align-items-center z-1"
                [ngClass]="editableEncounter?.status === 2 ? 'bg-primary-100' : 'surface-card' ">
                    <i class="pi pi-thumbs-up text-2xl md:text-4xl mb-2 md:mb-0 mr-0 md:mr-3"></i>
                    <div>
                        <div class="text-900 font-medium mb-1">Submission Approved</div>
                        <span class="text-600 text-sm hidden md:block">Provider research and scheduling underway</span>
                    </div>
                </div>
                <div class="w-full absolute top-50 left-100 surface-300 hidden md:block" style="transform: translateY(-50%); height: 2px"></div>
            </li>
            <li class="relative mr-0 md:mr-8 flex-auto">
                <div class="border-1 surface-border border-round p-3 flex flex-column md:flex-row align-items-center z-1"
                [ngClass]="editableEncounter?.status == 3 ? 'bg-primary-100' : 'surface-card' ">
                    <i class="pi pi-calendar-clock text-2xl md:text-4xl mb-2 md:mb-0 mr-0 md:mr-3"></i>
                    <div>
                        <div class="text-900 font-medium mb-1">Scheduled</div>
                        <span class="text-600 text-sm hidden md:block">Patient scheduled. Waiting for provider bill</span>
                    </div>
                </div>
            </li>
        </ul>
        <div class="m-2">

        </div>
        <ul class="list-none p-0 m-0 flex flex-column md:flex-row">
            <li class="relative mr-0 md:mr-8 flex-auto">
                <div class="border-1 surface-border border-round p-3 flex flex-column md:flex-row align-items-center z-1"
                [ngClass]="editableEncounter?.status == 4 ? 'bg-primary-100' : 'surface-card' ">
                    <i class="pi pi-receipt text-2xl md:text-4xl mb-2 md:mb-0 mr-0 md:mr-3"></i>
                    <div>
                        <div class="text-900 font-medium mb-1">Bill Received</div>
                        <span class="text-600 text-sm hidden md:block">Repricing process underway</span>
                    </div>
                </div>
                <div class="w-full absolute top-50 left-100 surface-300 hidden md:block" style="transform: translateY(-50%); height: 2px"></div>
            </li>
            <li class="relative mr-0 md:mr-8 flex-auto">
                <div class="border-1 surface-border border-round p-3 flex flex-column md:flex-row align-items-center z-1"
                [ngClass]="editableEncounter?.status == 5 ? 'bg-primary-100' : 'surface-card' ">
                    <i class="pi pi-money-bill text-2xl md:text-4xl mb-2 md:mb-0 mr-0 md:mr-3"></i>
                    <div>
                        <div class="text-900 font-medium mb-1">Confirmed</div>
                        <span class="text-600 text-sm hidden md:block">Bill repriced. Data being sent to finance</span>
                    </div>
                </div>
                <div class="w-full absolute top-50 left-100 surface-300 hidden md:block" style="transform: translateY(-50%); height: 2px"></div>
            </li>
            <li *ngIf="editableEncounter?.status != 6" class="relative mr-0 md:mr-8 flex-auto">
                <div class="border-1 surface-border border-round p-3 flex flex-column md:flex-row align-items-center z-1"
                [ngClass]="editableEncounter?.status == 7 ? 'bg-primary-100' : 'surface-card' ">
                    <i class="pi pi-check text-2xl md:text-4xl mb-2 md:mb-0 mr-0 md:mr-3"></i>
                    <div>
                        <div class="text-900 font-medium mb-1">Complete!</div>
                        <span class="text-600 text-sm hidden md:block">Provider paid and medical bill sent to adjuster</span>
                    </div>
                </div>
            </li>
            <li *ngIf="editableEncounter?.status == 6" class="relative mr-0 md:mr-8 flex-auto">
                <div class="border-1 surface-border border-round p-3 flex flex-column md:flex-row align-items-center z-1"
                [ngClass]="editableEncounter?.status == 6 ? 'bg-primary-100' : 'surface-card' ">
                    <i class="pi pi-check text-2xl md:text-4xl mb-2 md:mb-0 mr-0 md:mr-3"></i>
                    <div>
                        <div class="text-900 font-medium mb-1">Closed</div>
                        <span class="text-600 text-sm hidden md:block">Encounter Closed</span>
                    </div>
                </div>
            </li>
        </ul>
    </div>

    <!-- Encounter Details -->
    <div *ngIf="editableEncounter" style="height:400px" class="flex grid mt-5 m-2">
        <div class="col-12">
            <div class="flex w-full align-items-center justify-content-center mb-5 mt-2">
                <span class="flex gap-2">
                    <p-buttonGroup>
                        <p-button label="Diaries" icon="pi pi-book" (click)="diaryOp.toggle($event)"/>
                        <p-button label="Notes" icon="pi pi-pencil" (click)="noteOp.toggle($event)"/>
                        <p-button label="Email" icon="pi pi-send" (click)="emailDialogVisible = true"/>
                        <p-button label="Attachments" icon="pi pi-file" (click)="attachmentOp.toggle($event)"/>
                        <p-button label="Faxes" icon="pi pi-folder" (click)="faxDialogVisible = true"/>
                    </p-buttonGroup>
                    <p-button pTooltip="Download Documentation" icon="pi pi-download" [raised]="true" (click)="downloadDocuments()"></p-button>
                </span>
                <p-overlayPanel #diaryOp [style]="{width: '50vw', height:'40vh'}" styleClass="overflow-y-scroll">
                    <app-diary-list [handler]="encounterDiaryHandler" [diaries]="editableEncounter.diaries"></app-diary-list>
                </p-overlayPanel>
                <p-overlayPanel #noteOp [style]="{width: '50vw', height:'40vh'}" styleClass="overflow-y-scroll">
                    <app-encounter-notes-list [handler]="encounterNoteHandler" [encounter]="editableEncounter" [notes]="editableEncounter.notes"></app-encounter-notes-list>
                </p-overlayPanel>
                <p-dialog #emailOp [(visible)]="emailDialogVisible" [style]="{width: '50vw', height:'60vh'}" styleClass="overflow-y-scroll">
                    <div class="flex flex-column gap-2">
                        <p-tabView>
                            <p-tabPanel header="Sent">
                                <app-sent-email-list [emailHandler]="encounterEmailHandler" [emails]="editableEncounter.sentEmails"></app-sent-email-list>
                            </p-tabPanel>
                            <p-tabPanel header="Received">
                                <app-received-email-list [emails]="editableEncounter.receivedEmails"></app-received-email-list>
                            </p-tabPanel>
                        </p-tabView>
                    </div>
                </p-dialog>
                <p-overlayPanel #attachmentOp [style]="{width: '50vw', height:'40vh'}" styleClass="overflow-y-scroll">
                    <app-file-list [files]="editableEncounter.attachments" [uploader]="uploader" (modified)="attachmentsChanged($event)"></app-file-list>
                </p-overlayPanel>
                <!-- <p-overlayPanel #faxOp [style]="{width: '50vw', height:'40vh'}" styleClass="overflow-y-scroll">
                    <app-fax-scroller [handler]="encounterFaxHandler" [faxes]="editableEncounter.outboundFaxes" [files]="editableEncounter.attachments"></app-fax-scroller>
                </p-overlayPanel> -->
                <p-dialog #faxOp [(visible)]="faxDialogVisible" [style]="{width: '50vw', height:'60vh'}" styleClass="overflow-y-scroll">
                    <app-fax-scroller [handler]="encounterFaxHandler" [faxes]="editableEncounter.outboundFaxes"></app-fax-scroller>
                </p-dialog>

            </div>
            
        </div>
        <div class="col-6">
            <div class="flex grid">
                
                <div class="col-6">
                    <app-encounter-facility-block [encounter]="editableEncounter"></app-encounter-facility-block>
                </div>
                <div class="col-6">
                    <app-encounter-appointment-block [encounter]="editableEncounter"></app-encounter-appointment-block>
                </div>
            </div>
        </div>
        <div class="col-6">
            <div class="flex w-full align-items-center justify-content-center m-3">
                <p-button *ngIf="encounterLocked && billReceived && !encounterComplete " icon="pi pi-lock" text raised label="Unlock Encounter" (onClick)="unlockEncounter()"></p-button>
                <p-button *ngIf="!encounterLocked && billReceived && !encounterComplete" icon="pi pi-lock-open" label="Lock Encounter" text raised (onClick)="lockEncounter()"></p-button>    
            </div>

            <!-- Overlay for Medical Bill Editor -->
            <app-encounter-medical-bill-block [encounter]="editableEncounter"></app-encounter-medical-bill-block>
        </div>
    </div>

